import { render, staticRenderFns } from "./GridDigitacion.vue?vue&type=template&id=7d094ce0&"
import script from "./GridDigitacion.vue?vue&type=script&lang=js&"
export * from "./GridDigitacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports